import { store, store$ } from '@redux/store';
import { routingStateActions } from 'features/routing';
import { map, distinctUntilChanged, filter } from 'rxjs';
import { selectPage } from 'features/articleSearchResultsFacets';

/**
 * updateUrlPaging: Updates the page on the url.
 * @param {Number} pageNumber Number of the selected page.
 */
const updateUrlPaging = (pageNumber) => {
  
  // add "/" by business rule of the learning center (all url has / to the end)
  const pagingSegment = pageNumber > 1 ? `page-${pageNumber}/` : '';
  store.dispatch(routingStateActions.updatePagination(pagingSegment));
};

// observer to map search command but only emmit if the page have been changed
const onPageChange$ = store$.pipe(
  map(selectPage),
  filter(Boolean),
  distinctUntilChanged(),
);
  
onPageChange$.subscribe(updateUrlPaging);

